import _ from 'lodash'
import type {CssValue} from '../../constants'
import type {DecoratedStyleProperty} from '../../../../../decorations/styleProperties/constants'
import {hasValidKeys} from '../utils/object'
import {deserializeUrl, serializeUrl} from '../utils/url'

const VALID_KEYS = new Set(['value'])

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val) || _.isEmpty(val) || !hasValidKeys(val, VALID_KEYS)) {
        return undefined
    }

    const {value} = val

    if (!_.isString(value)) {
        return undefined
    }

    return serializeUrl(value)
}

const deserialize = (rule: CssValue): DecoratedStyleProperty | undefined => {
    const value = deserializeUrl(rule)
    if (value === undefined) {
        return undefined
    }

    return {value}
}

export default {
    serialize,
    deserialize
}
